import Seo from "@/components/Seo";
import PageHero from "@/components/PageHero";
import Gallery from "@/components/sections/Gallery";
import CTASection from "@/components/sections/CTASection";
import { IMAGES } from "@/data/content";

export default function Projects() {
  return (
    <>
      <Seo title="Projects | Genuine Forge — Chicago HVAC Installations" description="A portfolio of rooftop unit replacements, furnace and AC installs, mechanical rooms, and commercial HVAC work across Chicago." />
      <PageHero eyebrow="Portfolio" title="Projects" lede="Rooftop unit change-outs, furnace and AC installs, commercial mechanical spaces, and crane-coordinated lifts — documented like an engineering portfolio." image={IMAGES.mechanicalRoom} />
      <Gallery full />
      <CTASection />
    </>
  );
}
